import React, { useEffect } from 'react';
import { authClient } from '../../../lib/auth-client';
import { Loader2 } from 'lucide-react';

const ExitImpersonation = () => {
    useEffect(() => {
        authClient.admin.stopImpersonating().then(() => {
            window.location.replace('/user');
        }).catch(() => {
            window.location.replace('/login');
        });
    }, []);

    return (
        <div className="flex h-screen items-center justify-center">
            <Loader2 className="size-8 animate-spin text-muted-foreground" />
        </div>
    );
};

export default ExitImpersonation;
